<script setup lang="ts">
import {cx} from 'class-variance-authority'
import type {SuccessionBlock} from '~/types/legacy'
import type {WorkshopSuccession} from '~/types/workshop'
import type {Populated} from '~/types/populated'
import StatementPerson from '~/components/workshop/statement-person.vue'

const props = withDefaults(
  defineProps<{
    data: Exclude<Populated<SuccessionBlock> | Populated<WorkshopSuccession>, undefined>
    large?: boolean
  }>(),
  {
    large: true,
  }
)

const defaultStyling = 'w-5/6 text-2xl font-bold text-gray-900'
const lgWidth = cx(defaultStyling, {
  'lg:w-10/12': props.large,
  'lg:w-5/12': !props.large,
})
</script>

<template>
  <Container
    class="flex border-spacing-3 flex-col items-center justify-center space-y-2 border-b border-gray-200 bg-gray-50 py-12"
  >
    <Heading as="h2" size="caption"> {{ data.eyebrow }}</Heading>
    <div class="flex justify-center text-center">
      <span :class="lgWidth"> {{ data.title }}</span>
    </div>

    <StatementPerson v-if="data.person" :person="data.person" />
  </Container>
</template>
